module.exports = __webpack_public_path__ + "assets/img/main-logo-zhangjiakou.cdf026b0.png";